import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./NewLandingContent.css";
import { useDialog } from "../../context/DialogContext.js";
import CustomDialog from "../SignUpFormVerification/CustomDialog.jsx";
import { QRCode } from "../../constant/ImagesS3.js";
import { ROUTES } from "../../constant/routes.js";
import Roadmap from "../Roadmap/Roadmap.jsx";
import NewsList from "../NewsArticles/NewsList.jsx";
import SixDegreeSeperationSection from "../SixDegreeSeperationSection/SixDegreeSeperationSection.jsx";
import CoreValues from "../CoreValues/CoreValues.jsx";


const SERVICES = [
  { emoji: "🔧", name: "Home Repairs" },
  { emoji: "🩺", name: "Doctors" },
  { emoji: "🧑‍🏫", name: "Tutors" },
  { emoji: "✈️", name: "Travel Agents" },
  { emoji: "🚗", name: "Mechanics" },
  { emoji: "⚖️", name: "Lawyers" },
  { emoji: "📷", name: "Photographers" },
  { emoji: "🍳", name: "Cooks" },
  { emoji: "💇", name: "Salons" },
  { emoji: "🏠", name: "Brokers" },
  { emoji: "💍", name: "Matchmakers" },
  { emoji: "🎉", name: "Event Planners" },
];

const TESTIMONIALS_ROW1 = [
  {
    text: "My maasi recommended a tailor in Lucknow on Bataiyo. I'm in Bangalore. He stitched my wedding lehenga from saree photos on WhatsApp. No middleman, no markup.",
    name: "Nidhi Sharma",
    role: "Bangalore · Bride",
    initial: "N",
    dark: true,
  },
  {
    text: "I'm an electrician. On other apps I was paying 25% commission. Bataiyo gets me 8–10 jobs a week from people whose neighbours actually know me. Zero deductions.",
    name: "Ramesh Yadav",
    role: "Noida · Electrician, 14 yrs",
    initial: "R",
    dark: false,
  },
  {
    text: "We were new to Pune. In 24 hours, my colleague's friend's mother had recommended us a pediatrician, a maid, and a chai-wala. That's word of mouth, productised.",
    name: "Karan & Aisha",
    role: "Pune · Just moved",
    initial: "K",
    dark: false,
  },
];

const TESTIMONIALS_ROW2 = [
  {
    text: "I told my building’s WhatsApp group: \"anyone has a good carpenter?\" Got 14 messages, all guessing. Asked the same on Bataiyo. Got 3 names, all with stories. Hired in 20 minutes.",
    name: "Sanjana Iyer",
    role: "Mumbai · Mom of two",
    initial: "S",
    dark: false,
  },
  {
    text: "I run a small catering kitchen. I don’t do Instagram. I don’t pay for ads. Bataiyo brought me 60 orders last Diwali - all because aunties told other aunties. The original marketing.",
    name: "Lakshmi Devi",
    role: "Hyderabad · Home Caterer",
    initial: "L",
    dark: true,
  },
];

const COMPARISON_ROWS = [
  ["Provider commission", "15–30%", "0%"],
  ["Booking fee on user", "₹49–₹99", "₹0"],
  ["Reviews", "Anonymous", "From your network"],
  ["Promoted listings", "Yes", "Never"],
  ["Who recommends", "Strangers", "People you trust"],
];

const CheckIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="22"
    height="22"
  >
    <path d="m5 13 4 4L19 7" />
  </svg>
);

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M17.05 12.04c-.03-2.96 2.42-4.39 2.53-4.46-1.38-2.02-3.53-2.3-4.29-2.33-1.82-.18-3.56 1.07-4.48 1.07-.93 0-2.36-1.05-3.88-1.02-2 .03-3.84 1.16-4.87 2.95-2.07 3.6-.53 8.93 1.5 11.86.99 1.43 2.18 3.04 3.73 2.98 1.5-.06 2.07-.97 3.88-.97s2.32.97 3.9.94c1.61-.03 2.63-1.46 3.62-2.9 1.14-1.66 1.61-3.27 1.64-3.36-.04-.02-3.14-1.21-3.18-4.78ZM14.1 3.69c.83-1 1.39-2.4 1.24-3.78-1.2.05-2.65.8-3.5 1.8-.77.89-1.44 2.31-1.26 3.66 1.34.1 2.69-.68 3.52-1.68Z" />
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M3.6 1.7C3.2 2 3 2.5 3 3.2v17.6c0 .7.2 1.2.6 1.5l.1.1 9.8-9.8v-.2L3.6 1.7ZM17 16.7l-3.3-3.3 3.3-3.3 4 2.3c1.1.6 1.1 1.7 0 2.3l-4 2ZM14.1 13l-9.8 9.8c.4.4 1 .4 1.7 0l11.6-6.6L14.1 13ZM6 1.4 17.6 8l-3.5 3.5L4.3 1.7C4.7 1.3 5.4 1.3 6 1.4Z" />
  </svg>
);

const StoreBadges = () => (
  <div className="wom-store-row">
    <a
      className="wom-store-btn"
      href={ROUTES.APP_STORE_URL}
      target="_blank"
      rel="noreferrer"
    >
      <AppleIcon />
      <span>
        <span className="wom-store-small">Download on the</span>
        <span className="wom-store-big">App Store</span>
      </span>
    </a>
    <a
      className="wom-store-btn"
      href={ROUTES.PLAY_STORE_URL}
      target="_blank"
      rel="noreferrer"
    >
      <PlayIcon />
      <span>
        <span className="wom-store-small">Get it on</span>
        <span className="wom-store-big">Google Play</span>
      </span>
    </a>
  </div>
);

const NewLandingContent = () => {
  const { handleDialogOpen } = useDialog();
  const [isDownloadOpen, setIsDownloadOpen] = useState(false);

  const openDownload = () => setIsDownloadOpen(true);

  return (
    <div className="wom-root">
      {/* ===== HERO ===== */}
      <section className="wom-hero" id="hero">
        <div className="wom-wrap wom-hero-grid">
          {/* Left: headline + CTA */}
          <div className="wom-hero-text">
            <div className="wom-hero-eyebrow">
              <span className="wom-pulse" />
              World's First Digital Word-of-Mouth Platform
            </div>
            <h1 className="wom-h1">
              Word of mouth beats
              <br />
              every review system
              <br />
              <em className="wom-ital">ever built.</em>
            </h1>
            <p className="wom-lead">
              <span className="wom-inline-emoji" aria-hidden="true">❌</span>{" "}
              No one ever said "I found my best hotel/doctor/cook from an online review."
              They said -{" "}
              <span className="wom-quote-pill">
                <em>my friend told me about them.</em>
              </span>{" "}
              <span className="wom-inline-emoji" aria-hidden="true">✅</span>
              <br/>
              <br/>
              <span className="wom-inline-emoji" aria-hidden="true">📲</span>{" "}
              <strong>Bataiyo brings that to your pocket.</strong>{" "}
              Recommendations from your{" "}
              <span className="wom-text-hl">network</span>. No fake reviews.{" "}
              <span className="wom-text-hl">Zero commission. Forever.</span>
            </p>

            <div className="wom-hero-cta">
              <button className="wom-btn wom-btn-dark" onClick={openDownload}>
                Start asking your network
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                >
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </button>
              {/* <a className="wom-btn wom-btn-ghost" href="#wom-how">
                See how it works
              </a> */}
            </div>
            <StoreBadges />
          </div>

          {/* Right: phone mockup + floating bubbles */}
          <div className="wom-hero-stage">
            <div className="wom-bubble wom-b1">
              <span className="wom-bubble-av" style={{ background: "#E03B2F" }}>
                P
              </span>
              <div>
                <b>Priya recommended</b>
                "Ramesh ji - best AC technician in Noida. Fixed in 30 mins."
              </div>
            </div>
            <div className="wom-bubble wom-b2">
              <span className="wom-bubble-av" style={{ background: "#0E8E5C" }}>
                A
              </span>
              <div>
                <b>Arjun shared</b>
                "Dr. Mehta - pediatrician. My daughter actually wants to visit."
              </div>
            </div>
            <div className="wom-bubble wom-b3">
              <span className="wom-bubble-av" style={{ background: "#7C3AED" }}>
                S
              </span>
              <div>
                <b>Sneha tagged</b>
                "Use Bittu Travels for Manali. Mountain pro."
              </div>
            </div>
            <div className="wom-bubble wom-b4">
              <span className="wom-bubble-av" style={{ background: "#F59E0B" }}>
                R
              </span>
              <div>
                <b>Rahul asked</b>
                "Anyone know a good carpenter near Gurgaon Sector 49?"
              </div>
            </div>

            <div className="wom-phone">
              <div className="wom-phone-screen">
                <div className="wom-phone-notch" />
                <div className="wom-phone-top">
                  <div>
                    <div className="wom-phone-greet">Namaste,</div>
                    <div className="wom-phone-name">Aanya 👋</div>
                  </div>
                  <div className="wom-phone-avatar">A</div>
                </div>
                <div className="wom-phone-search">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <circle cx="11" cy="11" r="7" />
                    <path d="M21 21l-4.3-4.3" />
                  </svg>
                  Ask your network…
                </div>
                <div className="wom-phone-cards">
                  <div className="wom-rec-card">
                    <div className="wom-rec-head">
                      <div
                        className="wom-rec-avatar"
                        style={{ background: "#E03B2F" }}
                      >
                        M
                      </div>
                      <div>
                        <div className="wom-rec-svc">
                          Meera D.{" "}
                          <span className="wom-rec-tag">Trusted by 3</span>
                        </div>
                        <div className="wom-rec-by">
                          by <b>Priya, Karan +1</b>
                        </div>
                      </div>
                    </div>
                    <div className="wom-rec-quote">
                      "Honest pricing. Showed up on Sunday."
                    </div>
                    <div className="wom-rec-foot">
                      <span>
                        <span className="wom-stars">★★★★★</span> Plumbing
                      </span>
                      <span>📍 2.1 km</span>
                    </div>
                  </div>
                  <div className="wom-rec-card">
                    <div className="wom-rec-head">
                      <div
                        className="wom-rec-avatar"
                        style={{ background: "#0E8E5C" }}
                      >
                        V
                      </div>
                      <div>
                        <div className="wom-rec-svc">
                          Vinod Tutorials{" "}
                          <span className="wom-rec-tag">Family trusted</span>
                        </div>
                        <div className="wom-rec-by">
                          by <b>Mom 💛</b>
                        </div>
                      </div>
                    </div>
                    <div className="wom-rec-quote">
                      "He taught both my kids. Patient, kind."
                    </div>
                    <div className="wom-rec-foot">
                      <span>
                        <span className="wom-stars">★★★★★</span> Math Tutor
                      </span>
                      <span>📍 800 m</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== STATS BAR ===== */}
      <div className="wom-stats-bar">
        <div className="wom-wrap wom-stats-row">
          <div className="wom-stat">
            <div className="wom-stat-n">250+</div>
            <div className="wom-stat-l">Services across India</div>
          </div>
          <div className="wom-stat">
            <div className="wom-stat-n">0%</div>
            <div className="wom-stat-l">Commission. Forever.</div>
          </div>
          <div className="wom-stat">
            <div className="wom-stat-n">100%</div>
            <div className="wom-stat-l">Recommendations from your network</div>
          </div>
          <div className="wom-stat">
            <div className="wom-stat-n">1000+</div>
            <div className="wom-stat-l">Trusted referrals shared</div>
          </div>
        </div>
      </div>

      {/* ===== HOW IT WORKS ===== */}
      <section className="wom-how" id="wom-how">
        <div className="wom-wrap">
          <span className="wom-section-eyebrow">How it works</span>
          <h2 className="wom-section-title">
            Your network knows someone.
            <br />
            <em className="wom-serif">They always do.</em>
          </h2>
          <p className="wom-section-sub">
            Word of mouth travels through trust, not algorithms. Ask once on
            Bataiyo - your circle responds, and you find
            someone your network actually trusted.
          </p>

          {/* ── Network spread diagram ── */}
          <div className="wom-net-board">

            {/* Desktop: SVG network diagram */}
            <svg viewBox="0 0 900 360" className="wom-net-svg" aria-hidden="true">

              {/* YOU → Layer 1 */}
              <line x1="92"  y1="170" x2="228" y2="74"  stroke="#3b82f6" strokeWidth="1.8" strokeDasharray="7 5"/>
              <line x1="92"  y1="170" x2="228" y2="170" stroke="#3b82f6" strokeWidth="1.8" strokeDasharray="7 5"/>
              <line x1="92"  y1="170" x2="228" y2="266" stroke="#3b82f6" strokeWidth="1.8" strokeDasharray="7 5"/>
              {/* Layer 1 → Layer 2 */}
              <line x1="228" y1="74"  x2="408" y2="36"  stroke="#60a5fa" strokeWidth="1.4" strokeDasharray="6 5" opacity="0.7"/>
              <line x1="228" y1="74"  x2="408" y2="108" stroke="#60a5fa" strokeWidth="1.4" strokeDasharray="6 5" opacity="0.7"/>
              <line x1="228" y1="170" x2="408" y2="154" stroke="#60a5fa" strokeWidth="1.4" strokeDasharray="6 5" opacity="0.7"/>
              <line x1="228" y1="170" x2="408" y2="204" stroke="#60a5fa" strokeWidth="1.4" strokeDasharray="6 5" opacity="0.7"/>
              <line x1="228" y1="266" x2="408" y2="248" stroke="#60a5fa" strokeWidth="1.4" strokeDasharray="6 5" opacity="0.7"/>
              <line x1="228" y1="266" x2="408" y2="300" stroke="#60a5fa" strokeWidth="1.4" strokeDasharray="6 5" opacity="0.7"/>
              {/* Layer 2 → Provider */}
              <line x1="408" y1="36"  x2="578" y2="166" stroke="#93c5fd" strokeWidth="1" strokeDasharray="5 5" opacity="0.45"/>
              <line x1="408" y1="108" x2="578" y2="166" stroke="#93c5fd" strokeWidth="1" strokeDasharray="5 5" opacity="0.45"/>
              <line x1="408" y1="154" x2="578" y2="166" stroke="#93c5fd" strokeWidth="1" strokeDasharray="5 5" opacity="0.45"/>
              <line x1="408" y1="204" x2="578" y2="166" stroke="#93c5fd" strokeWidth="1" strokeDasharray="5 5" opacity="0.45"/>
              <line x1="408" y1="248" x2="578" y2="166" stroke="#93c5fd" strokeWidth="1" strokeDasharray="5 5" opacity="0.45"/>
              <line x1="408" y1="300" x2="578" y2="166" stroke="#93c5fd" strokeWidth="1" strokeDasharray="5 5" opacity="0.45"/>

              {/* ── YOU (r=36) ── */}
              <circle cx="92" cy="170" r="48" fill="#1570ef" opacity="0.14"/>
              <circle cx="92" cy="170" r="36" fill="#1570ef"/>
              {/* person silhouette: head + shoulders */}
              <circle cx="92" cy="161" r="10.5" fill="white" opacity="0.92"/>
              <path d="M70 193 Q70 174 92 174 Q114 174 114 193" fill="white" opacity="0.92"/>
              <text x="92" y="216" textAnchor="middle" fill="white" fontSize="14" fontWeight="700" fontFamily="Lexend,sans-serif">YOU</text>
              <text x="92" y="231" textAnchor="middle" fill="rgba(255,255,255,0.65)" fontSize="10" fontFamily="Lexend,sans-serif">Ask your network</text>

              {/* ── Priya · Friend (r=26) ── */}
              <circle cx="228" cy="74" r="26" fill="#c0392b"/>
              <circle cx="228" cy="67" r="7.5" fill="white" opacity="0.92"/>
              <path d="M212 91 Q212 77 228 77 Q244 77 244 91" fill="white" opacity="0.92"/>
              <text x="228" y="116" textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="10" fontFamily="Lexend,sans-serif">Priya · Friend</text>

              {/* ── Arjun · Colleague (r=26) ── */}
              <circle cx="228" cy="170" r="26" fill="#0E8E5C"/>
              <circle cx="228" cy="163" r="7.5" fill="white" opacity="0.92"/>
              <path d="M212 187 Q212 173 228 173 Q244 173 244 187" fill="white" opacity="0.92"/>
              <text x="228" y="212" textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="10" fontFamily="Lexend,sans-serif">Arjun · Colleague</text>

              {/* ── Mom · Family (r=26) ── */}
              <circle cx="228" cy="266" r="26" fill="#d97706"/>
              <circle cx="228" cy="259" r="7.5" fill="white" opacity="0.92"/>
              <path d="M212 283 Q212 269 228 269 Q244 269 244 283" fill="white" opacity="0.92"/>
              <text x="228" y="308" textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="10" fontFamily="Lexend,sans-serif">Mom · Family</text>

              {/* ── Layer 2 contacts (r=19) ── */}
              {/* R – purple */}
              <circle cx="408" cy="36"  r="19" fill="#7C3AED"/>
              <circle cx="408" cy="30"  r="5.5" fill="white" opacity="0.92"/>
              <path d="M397 48 Q397 39 408 39 Q419 39 419 48" fill="white" opacity="0.92"/>

              {/* S – pink */}
              <circle cx="408" cy="108" r="19" fill="#DB2777"/>
              <circle cx="408" cy="102" r="5.5" fill="white" opacity="0.92"/>
              <path d="M397 120 Q397 111 408 111 Q419 111 419 120" fill="white" opacity="0.92"/>

              {/* K – teal */}
              <circle cx="408" cy="154" r="19" fill="#059669"/>
              <circle cx="408" cy="148" r="5.5" fill="white" opacity="0.92"/>
              <path d="M397 166 Q397 157 408 157 Q419 157 419 166" fill="white" opacity="0.92"/>

              {/* N – amber */}
              <circle cx="408" cy="204" r="19" fill="#D97706"/>
              <circle cx="408" cy="198" r="5.5" fill="white" opacity="0.92"/>
              <path d="M397 216 Q397 207 408 207 Q419 207 419 216" fill="white" opacity="0.92"/>

              {/* V – blue */}
              <circle cx="408" cy="248" r="19" fill="#2563EB"/>
              <circle cx="408" cy="242" r="5.5" fill="white" opacity="0.92"/>
              <path d="M397 260 Q397 251 408 251 Q419 251 419 260" fill="white" opacity="0.92"/>

              {/* T – red */}
              <circle cx="408" cy="300" r="19" fill="#DC2626"/>
              <circle cx="408" cy="294" r="5.5" fill="white" opacity="0.92"/>
              <path d="M397 312 Q397 303 408 303 Q419 303 419 312" fill="white" opacity="0.92"/>

              {/* ── Trusted provider result card ── */}
              <rect x="576" y="86" width="240" height="166" rx="18" fill="white"/>
              <rect x="576" y="86" width="240" height="166" rx="18" fill="none" stroke="rgba(21,112,239,0.18)" strokeWidth="1.5"/>
              {/* Jagdish avatar: person silhouette */}
              <circle cx="608" cy="128" r="22" fill="#0d5fd6"/>
              <circle cx="608" cy="120" r="7"  fill="white" opacity="0.92"/>
              <path d="M593 147 Q593 133 608 133 Q623 133 623 147" fill="white" opacity="0.92"/>
              <text x="638" y="118" fill="#0a0a0a" fontSize="13" fontWeight="700" fontFamily="Lexend,sans-serif">Jagdish - Plumber</text>
              <text x="638" y="134" fill="#5b6473" fontSize="11" fontFamily="Lexend,sans-serif">Trusted by 6 in your network</text>
              <text x="638" y="150" fill="#5b6473" fontSize="11" fontFamily="Lexend,sans-serif">14 yrs experience · Noida</text>
              <text x="594" y="170" fill="#F59E0B" fontSize="14">★★★★★</text>
              <rect x="594" y="180" width="190" height="26" rx="13" fill="#1570ef"/>
              <text x="689" y="197" textAnchor="middle" fill="white" fontSize="11" fontWeight="700" fontFamily="Lexend,sans-serif">Hire · ₹0 Commission</text>
              <rect x="594" y="214" width="195" height="22" rx="11" fill="rgba(21,112,239,0.07)"/>
              <text x="691" y="229" textAnchor="middle" fill="#1570ef" fontSize="11" fontWeight="600" fontFamily="Lexend,sans-serif">4 in your network confirmed</text>

              {/* ── Step labels ── */}
              <rect x="34"  y="240" width="116" height="22" rx="11" fill="rgba(21,112,239,0.35)"/>
              <text x="92"  y="255" textAnchor="middle" fill="white" fontSize="10" fontWeight="700" fontFamily="Lexend,sans-serif">① You ask</text>

              <rect x="152" y="330" width="152" height="22" rx="11" fill="rgba(255,255,255,0.1)"/>
              <text x="228" y="345" textAnchor="middle" fill="rgba(255,255,255,0.85)" fontSize="10" fontWeight="700" fontFamily="Lexend,sans-serif">② Friends respond</text>

              <rect x="342" y="330" width="132" height="22" rx="11" fill="rgba(255,255,255,0.1)"/>
              <text x="408" y="345" textAnchor="middle" fill="rgba(255,255,255,0.85)" fontSize="10" fontWeight="700" fontFamily="Lexend,sans-serif">③ Chain expands</text>

              <rect x="584" y="256" width="208" height="22" rx="11" fill="rgba(21,112,239,0.35)"/>
              <text x="688" y="271" textAnchor="middle" fill="white" fontSize="10" fontWeight="700" fontFamily="Lexend,sans-serif">④ Hire with trust · 0% fee</text>
            </svg>

            {/* Mobile: vertical network diagram */}
            <div className="wom-net-mobile">
              <svg viewBox="0 0 320 480" className="wom-net-svg-v" aria-hidden="true">

                {/* ── Connection lines (drawn first, under nodes) ── */}
                {/* YOU → Layer 1 */}
                <line x1="160" y1="78"  x2="60"  y2="135" stroke="#3b82f6" strokeWidth="1.6" strokeDasharray="6 5"/>
                <line x1="160" y1="78"  x2="160" y2="135" stroke="#3b82f6" strokeWidth="1.6" strokeDasharray="6 5"/>
                <line x1="160" y1="78"  x2="260" y2="135" stroke="#3b82f6" strokeWidth="1.6" strokeDasharray="6 5"/>
                {/* Layer 1 → Layer 2 */}
                <line x1="60"  y1="175" x2="28"  y2="227" stroke="#60a5fa" strokeWidth="1.2" strokeDasharray="5 5" opacity="0.7"/>
                <line x1="60"  y1="175" x2="92"  y2="227" stroke="#60a5fa" strokeWidth="1.2" strokeDasharray="5 5" opacity="0.7"/>
                <line x1="160" y1="175" x2="148" y2="227" stroke="#60a5fa" strokeWidth="1.2" strokeDasharray="5 5" opacity="0.7"/>
                <line x1="160" y1="175" x2="192" y2="227" stroke="#60a5fa" strokeWidth="1.2" strokeDasharray="5 5" opacity="0.7"/>
                <line x1="260" y1="175" x2="248" y2="227" stroke="#60a5fa" strokeWidth="1.2" strokeDasharray="5 5" opacity="0.7"/>
                <line x1="260" y1="175" x2="294" y2="227" stroke="#60a5fa" strokeWidth="1.2" strokeDasharray="5 5" opacity="0.7"/>
                {/* Layer 2 → Provider */}
                <line x1="28"  y1="253" x2="160" y2="294" stroke="#93c5fd" strokeWidth="1" strokeDasharray="4 5" opacity="0.5"/>
                <line x1="92"  y1="253" x2="160" y2="294" stroke="#93c5fd" strokeWidth="1" strokeDasharray="4 5" opacity="0.5"/>
                <line x1="148" y1="253" x2="160" y2="294" stroke="#93c5fd" strokeWidth="1" strokeDasharray="4 5" opacity="0.5"/>
                <line x1="192" y1="253" x2="160" y2="294" stroke="#93c5fd" strokeWidth="1" strokeDasharray="4 5" opacity="0.5"/>
                <line x1="248" y1="253" x2="160" y2="294" stroke="#93c5fd" strokeWidth="1" strokeDasharray="4 5" opacity="0.5"/>
                <line x1="294" y1="253" x2="160" y2="294" stroke="#93c5fd" strokeWidth="1" strokeDasharray="4 5" opacity="0.5"/>

                {/* ── YOU ── */}
                <circle cx="160" cy="50" r="40" fill="#1570ef" opacity="0.12"/>
                <circle cx="160" cy="50" r="28" fill="#1570ef"/>
                <circle cx="160" cy="43" r="8.5" fill="white" opacity="0.92"/>
                <path d="M142 68 Q142 53 160 53 Q178 53 178 68" fill="white" opacity="0.92"/>
                <text x="160" y="88" textAnchor="middle" fill="white" fontSize="12" fontWeight="700" fontFamily="Lexend,sans-serif">YOU</text>
                <text x="160" y="100" textAnchor="middle" fill="rgba(255,255,255,0.65)" fontSize="10" fontFamily="Lexend,sans-serif">Ask your network</text>
                <rect x="110" y="106" width="100" height="18" rx="9" fill="rgba(21,112,239,0.4)"/>
                <text x="160" y="118" textAnchor="middle" fill="white" fontSize="9" fontWeight="700" fontFamily="Lexend,sans-serif">① You ask</text>

                {/* ── Layer 1: 3 friends ── */}
                <circle cx="60"  cy="155" r="20" fill="#c0392b"/>
                <circle cx="60"  cy="149" r="6"  fill="white" opacity="0.92"/>
                <path d="M48 170 Q48 160 60 160 Q72 160 72 170" fill="white" opacity="0.92"/>
                <text x="60" y="184" textAnchor="middle" fill="rgba(255,255,255,0.75)" fontSize="9" fontFamily="Lexend,sans-serif">Priya</text>

                <circle cx="160" cy="155" r="20" fill="#0E8E5C"/>
                <circle cx="160" cy="149" r="6"  fill="white" opacity="0.92"/>
                <path d="M148 170 Q148 160 160 160 Q172 160 172 170" fill="white" opacity="0.92"/>
                <text x="160" y="184" textAnchor="middle" fill="rgba(255,255,255,0.75)" fontSize="9" fontFamily="Lexend,sans-serif">Arjun</text>

                <circle cx="260" cy="155" r="20" fill="#d97706"/>
                <circle cx="260" cy="149" r="6"  fill="white" opacity="0.92"/>
                <path d="M248 170 Q248 160 260 160 Q272 160 272 170" fill="white" opacity="0.92"/>
                <text x="260" y="184" textAnchor="middle" fill="rgba(255,255,255,0.75)" fontSize="9" fontFamily="Lexend,sans-serif">Mom</text>

                <rect x="96" y="192" width="128" height="18" rx="9" fill="rgba(255,255,255,0.1)"/>
                <text x="160" y="204" textAnchor="middle" fill="rgba(255,255,255,0.85)" fontSize="9" fontWeight="700" fontFamily="Lexend,sans-serif">② Friends respond</text>

                {/* ── Layer 2: 6 small contacts ── */}
                <circle cx="28"  cy="240" r="13" fill="#7C3AED"/>
                <circle cx="28"  cy="235" r="4"  fill="white" opacity="0.92"/>
                <path d="M20 247 Q20 242 28 242 Q36 242 36 247" fill="white" opacity="0.92"/>

                <circle cx="92"  cy="240" r="13" fill="#DB2777"/>
                <circle cx="92"  cy="235" r="4"  fill="white" opacity="0.92"/>
                <path d="M84 247 Q84 242 92 242 Q100 242 100 247" fill="white" opacity="0.92"/>

                <circle cx="148" cy="240" r="13" fill="#059669"/>
                <circle cx="148" cy="235" r="4"  fill="white" opacity="0.92"/>
                <path d="M140 247 Q140 242 148 242 Q156 242 156 247" fill="white" opacity="0.92"/>

                <circle cx="192" cy="240" r="13" fill="#D97706"/>
                <circle cx="192" cy="235" r="4"  fill="white" opacity="0.92"/>
                <path d="M184 247 Q184 242 192 242 Q200 242 200 247" fill="white" opacity="0.92"/>

                <circle cx="248" cy="240" r="13" fill="#2563EB"/>
                <circle cx="248" cy="235" r="4"  fill="white" opacity="0.92"/>
                <path d="M240 247 Q240 242 248 242 Q256 242 256 247" fill="white" opacity="0.92"/>

                <circle cx="294" cy="240" r="13" fill="#DC2626"/>
                <circle cx="294" cy="235" r="4"  fill="white" opacity="0.92"/>
                <path d="M286 247 Q286 242 294 242 Q302 242 302 247" fill="white" opacity="0.92"/>

                <rect x="96" y="261" width="128" height="18" rx="9" fill="rgba(255,255,255,0.1)"/>
                <text x="160" y="273" textAnchor="middle" fill="rgba(255,255,255,0.85)" fontSize="9" fontWeight="700" fontFamily="Lexend,sans-serif">③ Chain expands</text>

                {/* ── Provider result card ── */}
                <rect x="40" y="292" width="240" height="152" rx="16" fill="white"/>
                <rect x="40" y="292" width="240" height="152" rx="16" fill="none" stroke="rgba(21,112,239,0.18)" strokeWidth="1.5"/>
                <circle cx="74"  cy="326" r="20" fill="#0d5fd6"/>
                <circle cx="74"  cy="319" r="6.5" fill="white" opacity="0.92"/>
                <path d="M61 343 Q61 330 74 330 Q87 330 87 343" fill="white" opacity="0.92"/>
                <text x="100" y="319" fill="#0a0a0a" fontSize="12" fontWeight="700" fontFamily="Lexend,sans-serif">Jagdish</text>
                <text x="100" y="333" fill="#5b6473" fontSize="10" fontFamily="Lexend,sans-serif">Plumber · 14 yrs</text>
                <text x="100" y="347" fill="#5b6473" fontSize="10" fontFamily="Lexend,sans-serif">Noida · 6 in network</text>
                <text x="52"  y="367" fill="#F59E0B" fontSize="14">★★★★★</text>
                <rect x="52"  y="374" width="216" height="24" rx="12" fill="#1570ef"/>
                <text x="160" y="390" textAnchor="middle" fill="white" fontSize="11" fontWeight="700" fontFamily="Lexend,sans-serif">Hire · ₹0 Commission</text>
                <rect x="52"  y="406" width="216" height="20" rx="10" fill="rgba(21,112,239,0.07)"/>
                <text x="160" y="420" textAnchor="middle" fill="#1570ef" fontSize="10" fontWeight="600" fontFamily="Lexend,sans-serif">4 in your network confirmed</text>

                <rect x="80" y="452" width="160" height="20" rx="10" fill="rgba(21,112,239,0.35)"/>
                <text x="160" y="465" textAnchor="middle" fill="white" fontSize="9" fontWeight="700" fontFamily="Lexend,sans-serif">④ Hire with trust · 0% fee</text>

              </svg>
            </div>
          </div>

          {/* ── Step detail cards ── */}
          <div className="wom-net-steps">
            <div className="wom-net-step">
              <div className="wom-net-step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <div>
                <h4>Ask your circle</h4>
                <p>"Looking for a plumber in Sector 49." Your network gets a soft nudge - no group spam, no public broadcast.</p>
              </div>
            </div>
            <div className="wom-net-step">
              <div className="wom-net-step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="5" r="3" />
                  <path d="M6 22v-4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4" />
                  <path d="M2 17a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5" />
                </svg>
              </div>
              <div>
                <h4>Your network responds</h4>
                <p>Friends, family and trusted neighbours share who they've actually hired. Their trust travels through the chain to you.</p>
              </div>
            </div>
            <div className="wom-net-step">
              <div className="wom-net-step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m9 11 3 3L22 4" />
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                </svg>
              </div>
              <div>
                <h4>Hire with confidence · 0% fee</h4>
                <p>Call or book directly. The provider keeps 100% of what you pay. Zero commission, forever - written into our founding promise.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY WORD OF MOUTH ===== */}
      <section className="wom-why" id="wom-why">
        <div className="wom-wrap">
          <span className="wom-section-eyebrow">Why Word of Mouth</span>
          <h2 className="wom-section-title">
            The best review is always someone saying
            <br />
            <em className="wom-serif">"I trust someone"</em>
          </h2>
          <p className="wom-section-sub">
            88% of consumers trust personal recommendations more than any other
            form of marketing. Bataiyo is the first platform built around that
            single, ancient truth.
          </p>
          <div className="wom-why-grid">
            <div className="wom-card">
              <div className="wom-card-ico">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 12a8 8 0 1 1-3-6.2" />
                  <path d="m9 11 3 3L22 4" />
                </svg>
              </div>
              <h3>No fake reviews</h3>
              <p>
                Every recommendation is tied to a real person in your network.
                No bots, no paid reviews, no "5-star" theatre.
              </p>
            </div>
            <div className="wom-card">
              <div className="wom-card-ico">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="8" r="4" />
                  <path d="M3 21a9 9 0 0 1 18 0" />
                </svg>
              </div>
              <h3>People, not algorithms</h3>
              <p>
                See who recommended what. Filter by friends, family, neighbours.
                The closer to you, the higher it ranks.
              </p>
            </div>
            <div className="wom-card wom-card-dark">
              <div className="wom-card-ico">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 2 4 6v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V6l-8-4Z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
              </div>
              <h3>Zero paid ads</h3>
              <p>
                No one pays to be at the top. The best plumber on Bataiyo is
                the one your community keeps sending business to.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ZERO COMMISSION ===== */}
      <section className="wom-commission-section" id="wom-commission">
        <div className="wom-wrap">
          <div className="wom-commission">
            <div>
              <span className="wom-section-eyebrow wom-eyebrow-light">
                Zero. Commission. Forever.
              </span>
              <h2 className="wom-commission-h2">
                Trust doesn't charge
                <br />
                commission.
                <br />
                <em className="wom-serif">Neither do we.</em>
              </h2>
              <p className="wom-commission-p">
                Other apps clip 20–30% from the person doing the actual work.
                Bataiyo doesn't take a single rupee from service providers -
                not now, not after Series A, not ever. It's written into our
                constitution.
              </p>
              <div className="wom-promise">
                <div className="wom-promise-row">
                  <CheckIcon />
                  Service providers keep 100% of their earnings
                </div>
                <div className="wom-promise-row">
                  <CheckIcon />
                  No "convenience fees" hidden in your bill
                </div>
                <div className="wom-promise-row">
                  <CheckIcon />
                  No paid placements. No promoted listings. Ever.
                </div>
              </div>
            </div>

            <div className="wom-comparison">
              <div className="wom-compare-head">
                <span>&nbsp;</span>
                <span>Others</span>
                <span>Bataiyo</span>
              </div>
              {COMPARISON_ROWS.map(([label, bad, good]) => (
                <div key={label} className="wom-compare-row">
                  <span className="wom-compare-label">{label}</span>
                  <span className="wom-compare-bad">{bad}</span>
                  <span className="wom-compare-good">{good}</span>
                </div>
              ))}
            </div>

            <div className="wom-big-zero" aria-hidden="true">
              0
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY WE'RE DOING THIS ===== */}
      <section className="wom-mission" id="wom-mission">
        <div className="wom-wrap">
          <div className="wom-mission-head">
            <span className="wom-section-eyebrow">Why we're doing this</span>
            <h2 className="wom-section-title">
              We're not building this
              <br />
              <em className="wom-serif">to make money.</em>
            </h2>
            <p className="wom-section-sub wom-mission-sub">
              Zero commission isn't a launch offer or a growth hack - it's the
              whole point. We don't want to make money out of the trust between
              you and your network.
            </p>
          </div>

          <div className="wom-mission-belief">
            <span className="wom-mission-qmark" aria-hidden="true">
              "
            </span>
            <p>
              We believe the world is shifting from a{" "}
              <strong>centralised system</strong> to a{" "}
              <strong>trust-based system</strong>. When that change happens, we
              want to make sure there are{" "}
              <em className="wom-serif">no hurdles</em> in its way - especially
              the <strong>financial one</strong>.
            </p>
          </div>

          <div className="wom-mission-grid">
            <div className="wom-mission-card">
              <div className="wom-card-ico">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 3a9 9 0 0 0 0 18M3 12h18" />
                </svg>
              </div>
              <h3>From centralised to trust-based</h3>
              <p>
                For decades, we've needed a middleman in the middle to feel safe.
                That era is ending. Trust between real people is becoming the
                system itself.
              </p>
            </div>
            <div className="wom-mission-card">
              <div className="wom-card-ico">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M6 3h12M6 8h12M9 3c8 4 3 9 0 18M15 3c-8 4-3 9 0 18" />
                </svg>
              </div>
              <h3>No financial hurdle</h3>
              <p>
                The moment money stands between a recommendation and the person
                who needs it, trust breaks. So we took the money out - 0%
                commission, forever.
              </p>
            </div>
            <div className="wom-mission-card">
              <div className="wom-card-ico">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 2 4 6v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V6l-8-4Z" />
                  <path d="M12 8v4l3 2" />
                </svg>
              </div>
              <h3>Clearing the path for the change</h3>
              <p>
                Bataiyo is our small way of making sure that when the world
                changes, trust can travel freely - without a fee waiting to slow
                it down.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SERVICES GRID ===== */}
      <section className="wom-services" id="wom-services">
        <div className="wom-wrap">
          <div className="wom-services-bar">
            <div>
              <span className="wom-section-eyebrow">250+ Services</span>
              <h2 className="wom-section-title">
                Whatever you need,
                <br />someone in your network
                <br /><em className="wom-serif">has been there.</em>
              </h2>
              <p className="wom-section-sub">
                Every category, the same rule: you only see who your circle has
                recommended.
              </p>
            </div>
            <Link to={ROUTES.SERVICES} className="wom-btn wom-btn-blue">
              Browse all services
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              >
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
          <div className="wom-svc-grid">
            {SERVICES.map((s) => (
              <div key={s.name} className="wom-svc">
                <div className="wom-svc-emoji">{s.emoji}</div>
                <div className="wom-svc-name">{s.name}</div>
              </div>
            ))}
          </div>
          <p className="wom-svc-foot">
            …and 238 more.{" "}
            <Link to={ROUTES.SERVICES} className="wom-svc-link">
              See the full directory →
            </Link>
          </p>
        </div>
      </section>
      
      {/* ===== SixDegreeSeperationSection ===== */}
      <SixDegreeSeperationSection/>

      {/* ===== Roadmap ===== */}
      <Roadmap/>

      {/* ===== NewsList ===== */}
      <NewsList/>

      {/* ===== CoreValues ===== */}
      <CoreValues/>
      
      {/* ===== TESTIMONIALS ===== */}
      <section className="wom-testimonials" id="wom-stories">
        <div className="wom-wrap">
          <span className="wom-section-eyebrow wom-eyebrow-light">
            Real stories
          </span>
          <h2 className="wom-section-title wom-title-light">
            The recommendation was always there.{" "}
            <em className="wom-serif">
              We just put it on a phone.
            </em>
          </h2>
          <div className="wom-t-grid">
            {TESTIMONIALS_ROW1.map((t) => (
              <div
                key={t.name}
                className={`wom-quote${t.dark ? " wom-quote-dark" : ""}`}
              >
                <span className="wom-quote-mark">"</span>
                <p>{t.text}</p>
                <div className="wom-who">
                  <div className="wom-who-av">{t.initial}</div>
                  <div>
                    <b>{t.name}</b>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="wom-t-row-2">
            {TESTIMONIALS_ROW2.map((t) => (
              <div
                key={t.name}
                className={`wom-quote${t.dark ? " wom-quote-dark" : ""}`}
              >
                <span className="wom-quote-mark">"</span>
                <p>{t.text}</p>
                <div className="wom-who">
                  <div className="wom-who-av">{t.initial}</div>
                  <div>
                    <b>{t.name}</b>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className="wom-cta-section">
        <div className="wom-wrap">
          <div className="wom-cta-card">
            <div>
              <span className="wom-section-eyebrow wom-eyebrow-glass">
                Join the movement
              </span>
              <h2 className="wom-cta-h2">
                First platform for
                <br />
                <em className="wom-serif">word of mouth</em>
                <br />
                digital marketing.
              </h2>
              <p className="wom-cta-p">
                Built on trust. Funded by users. Powered by your network. Free
                for the people doing the work - and the people hiring them.
              </p>
              <StoreBadges />
            </div>
            <div className="wom-qr-block">
              <img
                src={QRCode}
                alt="Scan to download Bataiyo"
                className="wom-qr-img"
                width="180"
                height="180"
              />
              <div className="wom-qr-label">
                <b>Scan to download</b>
                Works on iOS &amp; Android
              </div>
            </div>
          </div>
        </div>
      </section>

      {handleDialogOpen && (
        <CustomDialog
          isDialogOpen={isDownloadOpen}
          handleClose={() => setIsDownloadOpen(false)}
        />
      )}
    </div>
  );
};

export default NewLandingContent;
